<template>
  <section class="p-box">
    <form class="p-box__header">
      <div class="p-filtersA">
        <div class="p-filtersA__left">
          <button @click.prevent="changeLayout()">
            <div v-if="type==='grid'" class="displayChange">
              <Icon name="iconList" />
              {{ $t('pages.CompaniesProducts.displayChange.list') }}
            </div>
            <div v-else class="displayChange">
              <Icon name="iconGrid" />
              {{ $t('pages.CompaniesProducts.displayChange.grid') }}
            </div>
          </button>
          <div v-if="!categoriesLoading" class="categoriesOption">
            <Select v-model="categoryId" :options="categoriesOption" @input="handleQuery" />
          </div>
        </div>

        <div class="p-filtersA__right">
          <form class="c-searchField" onsubmit="return false;">
            <input
              v-model="searchQuery"
              type="text"
              class="searchForm"
              :placeholder="$t('labels.search')"
              @keydown.enter="search"
            >
            <Icon name="iconSearch" />
          </form>
        </div>
      </div>
    </form>
    <div class="p-box__body">
      <Loading v-show="loading" />
      <template v-if="!loading">
        <Grid v-if="type === 'grid'"
              :products="products"
              :meta="meta"
              :store-uuid="storeUuid"
              :is-editable="isEditable"
        />
        <List v-else-if="type === 'list'"
              :products="products"
              :meta="meta"
              :store-uuid="storeUuid"
              :is-editable="isEditable"
              @handle-delete="handleDeleteProductStore"
        />
        <div v-if="products && products.length !== 0" class="p-controller">
          <div class="p-controller__count">
            <p class="p-controller__count__name">{{ $t('labels.perPageCount') }}</p>
            <div class="p-controller__count__select">
              <select :value="displayNumber" @change="changeDisplayNumber($event)">
                <option v-for="item in 5" :key="item" :value="item * 50">{{ item * 50 }}</option>
              </select>
            </div>
            <p class="p-controller__count__current">{{ startDataNumber }}-{{ endDataNumber }}</p>
          </div>
          <div class="p-controller__navi">
            <button
              type="button"
              :disabled="loading || currentPage === 1"
              class="p-controller__navi__prev"
              @click="goPrevPage"
            >
              <Icon name="arrowLeft" />
            </button>
            <button
              type="button"
              :disabled="loading || currentPage >= totalPages"
              class="p-controller__navi__next"
              @click="goNextPage"
            >
              <Icon name="arrowRight" />
            </button>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Loading from '../Loading'
import Icon from '../Icon'
import Select from '../../components/Select'
import Grid from '../../components/CompaniesProducts/Grid'
import List from '../../components/CompaniesProducts/List'

export default {
  name: 'ProductList',
  components: {
    Loading,
    Icon,
    Select,
    Grid,
    List
  },
  props: {
    companyUuid: {
      type: String,
      required: true,
    },
    storeUuid: {
      type: String,
      required: true,
    },
    isEditable: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      categoryId: '',
      searchQuery: '',
      currentPage: 1,
      type: 'list',
    }
  },
  computed: {
    ...mapState({
      products: state => state.companiesStoreProducts.data,
      meta: state => state.companiesStoreProducts.meta,
      productsLoading: state => state.companiesStoreProducts.loading,
      categories: state => state.companiesProductCategories.data,
      categoriesLoading: state => state.companiesProductCategories.loading,
      displayNumber: state => state.filters.displayNumber,
    }),
    categoriesOption() {
      const obj = {}
      this.categories.forEach(v => {
        obj[v.name] = v.id
      })
      const keys = Object.keys(obj).sort()
      const sortedObj = {}
      sortedObj[this.$t('pages.CompaniesLocationStoreProduct.optionAll')] = null
      for(let key of keys) {
        sortedObj[key] = obj[key]
      }
      return sortedObj
    },
    loading() {
      return this.productsLoading || this.categoriesLoading
    },
    startDataNumber() {
      return (this.currentPage - 1) * this.displayNumber + 1
    },
    endDataNumber() {
      return this.startDataNumber + this.products.length - 1
    },
    totalPages() {
      return this.meta?.totalPages
    },
  },
  created() {
    this.readProductCategories()
    this.readStoreProducts()
  },
  methods: {
    ...mapActions({
      readStoreProducts: 'companiesStoreProducts/readStoreProducts',
      readProductCategories: 'companiesProductCategories/readProductCategories',
      setDisplayNumber: 'filters/setDisplayNumber',
      deleteProductStore: 'companiesProduct/deleteProductStore',
    }),
    goPrevPage() {
      --this.currentPage
      this.changePage()
    },
    goNextPage() {
      ++this.currentPage
      this.changePage()
    },
    changePage() {
      const query = { ...this.$route.query, 'page': this.currentPage }
      window.scrollTo({ top: 0 })
      this.handleQuerySubmit(query)
    },
    changeDisplayNumber(e) {
      this.resetPage()
      this.setDisplayNumber(e.target.value)
      this.readStoreProducts()
    },
    search(event) {
      if (event.keyCode !== 13) return
      if (this.searchQuery === (this.$route.query['q[title_cont]'] || '')) return

      this.handleQuery()
    },
    handleQuery() {
      this.resetPage()
      const query = {
        ...this.$route.query,
        'q[title_cont]': this.searchQuery || undefined,
        'q[category_id_eq]': this.categoryId || undefined,
      }
      this.handleQuerySubmit(query)
    },
    resetPage() {
      this.currentPage = 1
      this.$route.query.page = undefined
    },
    handleQuerySubmit(query) {
      this.$router.push({ query: query })
      this.readStoreProducts()
    },
    changeLayout() {
      if(this.type === 'list') {
        this.type = 'grid'
      } else {
        this.type = 'list'
      }
      return
    },
    async handleDeleteProductStore(storeId) {
      if (!confirm(this.$t('pages.CompaniesLocationStoreProduct.deleteConfirm'))) return

      const isSuccess = await this.deleteProductStore(storeId)
      if(!isSuccess) return

      this.readStoreProducts()
    },
  },

}
</script>

<style lang="scss" scoped>
@import '../../../../stylesheets/biz_spa/foundation/_var.scss';

.searchForm {
  height: 38px;
  padding: 8px 6px 8px 48px;
}

.categoriesOption {
  margin-left: 20px;
}
</style>

